// views/networked-status.js: B2-14 pure header status line.
//
// Extracted from NetworkedGameView's inline statusText so Node tests can
// pin it. The line follows current_turn_seat exactly: an older revision
// read a possibly-stale isMyTurn flag and showed "Your bid" while another
// seat was on turn (seen with the human as stuck dealer in round 2).

/**
 * @param {{
 *   connectionLost: boolean,
 *   gameOver: boolean,
 *   gameState: any|null,
 *   myLuaSeat: number,
 *   currentState: string|null,
 *   isMyDealerDiscard: boolean,
 *   trickTaker?: number|null,
 * }} args
 * @returns {string}
 */
export function networkedStatusText({
  connectionLost,
  gameOver,
  gameState,
  myLuaSeat,
  currentState,
  isMyDealerDiscard,
  trickTaker = null,
}) {
  if (connectionLost) return 'Connection lost';
  if (gameOver) return 'Game over';
  if (!gameState) return 'Loading game…';
  // J5: while a trick clears, who takes it (the turn chip's words).
  if (trickTaker != null) {
    if (trickTaker === myLuaSeat) return 'You take it';
    const occs = gameState.seat_occupants ?? null;
    const who = occs ? (occs[trickTaker]?.display_name ?? occs[String(trickTaker)]?.display_name) : null;
    return `${who ?? `Seat ${trickTaker}`} takes it`;
  }
  if (currentState === 'end_of_hand' || currentState === 'score') {
    return 'Hand complete';
  }
  if (currentState === 'dealer_discard') {
    return isMyDealerDiscard ? 'Pick a card to discard' : 'Dealer is discarding…';
  }
  const seat = gameState.current_turn_seat;
  if (seat != null && seat === myLuaSeat) {
    if (currentState === 'bid_r1' || currentState === 'bid_r2') {
      return 'Your bid';
    }
    return 'Your turn';
  }
  if (seat == null) return 'Waiting…';
  const occs = gameState.seat_occupants ?? null;
  const name = occs ? (occs[seat]?.display_name ?? occs[String(seat)]?.display_name) : null;
  return name ? `Waiting on ${name}` : `Waiting on seat ${seat}`;
}
